import type { SerializedDocumentInvoice } from '@enmon/commons/lib/tools';
import { BaseApiClient } from './baseApiClient';

export type InvoicesFilter = {
  search: string | null;
  documentInvoiceIds: string | null;
  customer: string | null;
  status: string | null;
};

export interface UpdateDocumentInvoiceArgs {
  id: SerializedDocumentInvoice['id'];
  values: Partial<SerializedDocumentInvoice>;
}

export class DocumentInvoicesApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('document-invoices', undefined, jwt);
  }

  public async update({ id, values }: UpdateDocumentInvoiceArgs): Promise<SerializedDocumentInvoice> {
    const response = await this.axios.put<SerializedDocumentInvoice>(`${id}`, { data: values });
    return response.data;
  }

  public async sync(id: SerializedDocumentInvoice['id']) {
    await this.axios.put(`${id}/sync`);
  }

  public async getExport(filter: InvoicesFilter, format: 'csv' | 'excel') {
    const response = await this.axios.get<Blob>(format, {
      params: filter,
      responseType: 'blob',
    });

    return response.data;
  }

  public async processBatch(filter: InvoicesFilter) {
    return await this.axios.post(
      `process-batch`,
      {},
      {
        params: filter,
      },
    );
  }

  public async delete(id: SerializedDocumentInvoice['id']) {
    await this.axios.delete(`${id}`);
  }
}
